/**
 * Directives d'indexation d'une page (phase 1 du plan SEO, docs/seo/).
 *
 * Toutes les routes servent le même index.html : le HTML d'origine ne porte donc NI
 * canonique NI noindex, et c'est le JavaScript qui les pose selon la route, comme le
 * prévoit la documentation Google « JavaScript SEO basics » (lue le 2026-10-26) :
 *  - « noindex » ajouté en JavaScript : correction recommandée des fausses 404 d'une
 *    application d'une seule page (une URL inexistante répond 200, mesuré le 26/10) ;
 *  - canonique posée en JavaScript : prise en compte au rendu, tant que le HTML d'origine
 *    n'en déclare pas une autre. Ne JAMAIS en ajouter une dans public/index.html.
 *
 * Règle :
 *  - hôte hors production (staging, aperçus *.azurestaticapps.net, localhost) → noindex :
 *    ils servent le même robots.txt, une ouverture de l'indexation les exposerait aussi ;
 *  - page absente de publicRoutes.json (écrans connectés, connexion, 404) → noindex ;
 *  - page publique → indexable, canonique sur www, description propre à la page.
 *    app.kaneabourse.com n'est pas redirigé (jeton de session et application installée
 *    sont liés à l'origine) : la canonique suffit à regrouper ses pages sur www.
 */
import table from './publicRoutes.json';

export const ORIGINE_CANONIQUE: string = table.canonicalOrigin;

export const HOTES_PRODUCTION: readonly string[] = [
  'www.kaneabourse.com',
  'kaneabourse.com',
  'app.kaneabourse.com',
];

export interface DirectivesSeo {
  indexable: boolean;
  canonique: string | null;
  description: string | null;
}

const normaliser = (chemin: string): string =>
  chemin.length > 1 && chemin.endsWith('/') ? chemin.slice(0, -1) : chemin;

export function directivesSeo(hote: string, chemin: string): DirectivesSeo {
  const fermee: DirectivesSeo = { indexable: false, canonique: null, description: null };
  if (!HOTES_PRODUCTION.includes(hote.toLowerCase())) return fermee;
  const route = table.routes.find((r) => r.path === normaliser(chemin));
  if (!route) return fermee;
  return { indexable: true, canonique: `${ORIGINE_CANONIQUE}${route.path}`, description: route.description };
}
